import React, { useEffect, useState } from 'react';
import {
  getFirestore,
  collection,
  getDocs
} from '@firebase/firestore';
import { app } from '../../firebase';
import Table from 'react-bootstrap/Table';
import Card from 'react-bootstrap/Card';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Badge from 'react-bootstrap/Badge';
import Button from 'react-bootstrap/Button';

function MonthlyTargetsComp() {
  const db = getFirestore(app);
  const [totalSalaries, setTotalSalaries] = useState(0);
  const [rentAmount, setRentAmount] = useState(0);
  const [internetAmount, setInternetAmount] = useState(0);
  const [stimaAmount, setstimaAmount] = useState(0);
  const [marketingBudgetAmount, setMarketingBudgetAmount] = useState(0);

  useEffect(() => {
    const fetchSalaries = async () => {
      const querySnapshot = await getDocs(collection(db, "Employees"));
      let total = 0;
      querySnapshot.forEach((doc) => {
        const salary = parseInt(doc.data().salary || '0');
        if (!isNaN(salary)) total += salary;
      });
      setTotalSalaries(total);
    };

    const fetchBills = async () => {
      const billsSnapshot = await getDocs(collection(db, "Bills"));
      billsSnapshot.forEach((doc) => {
        const data = doc.data();
        if (data.billTitle === 'Rent') {
          setRentAmount(parseInt(data.billAmount || '0'));
        }
        if (data.billTitle === 'Office Internet') {
          setInternetAmount(parseInt(data.billAmount || '0'));
        }
        if(data.billTitle === "Electricity"){
          setstimaAmount(parseInt(data.billAmount || '0'));
        }
      });
    };

    const fetchMarketingBudget = async () => {
      const marketingSnapshot = await getDocs(collection(db, "marketingBudget"));
      let total = 0;
      marketingSnapshot.forEach((doc) => {
        const amount = parseInt(doc.data().amount || '0');
        if (!isNaN(amount)) total += amount;
      });
      setMarketingBudgetAmount(total);
    };

    fetchSalaries();
    fetchBills();
    fetchMarketingBudget();
  }, []);

  const fullExpenses = [
    { item: 'Marketing Campaigns', category: 'Marketing', amount: marketingBudgetAmount, date: '2025-05-01', by: 'System' },
    { item: 'Rent', category: 'Operations', amount: rentAmount, date: '2025-05-01', by: 'System' },
    { item: 'Internet & Utilities', category: 'Operations', amount: internetAmount, date: '2025-05-01', by: 'System' },
    { item: 'Electricity & Utilities', category: 'Operations', amount: stimaAmount, date: '2025-05-01', by: 'System' },
    { item: 'Salaries', category: 'Human Resource', amount: totalSalaries, date: '2025-05-01', by: 'System' }
  ];

  const totalExpenses = fullExpenses.reduce((acc, exp) => acc + exp.amount, 0);
  const savings = totalExpenses * 0.2;
  const monthlyTarget = totalExpenses + savings;

  return (
    <div className="teamsComponent">
      <h3 className="mb-4">Monthly Targets Overview</h3>

      <Row className="mb-4 g-3">
        <Col md={4}>
          <Card className="shadow-sm border-0">
            <Card.Body>
              <Card.Title>Total Recurring Expenses</Card.Title>
              <h4 className="text-danger">KES {totalExpenses.toLocaleString()}</h4>
              <Badge bg="danger">This Month</Badge>
            </Card.Body>
          </Card>
        </Col>
        <Col md={4}>
          <Card className="shadow-sm border-0">
            <Card.Body>
              <Card.Title>20% Savings Target</Card.Title>
              <h4 className="text-success">KES {savings.toLocaleString()}</h4>
              <Badge bg="success">Automatic Target</Badge>
            </Card.Body>
          </Card>
        </Col>
        <Col md={4}>
          <Card className="shadow-sm border-0 bg-primary text-white">
            <Card.Body>
              <Card.Title>Monthly Target</Card.Title>
              <h4>KES {monthlyTarget.toLocaleString()}</h4>
              <Badge bg="light" text="dark">Expenses + 20% Savings</Badge>
            </Card.Body>
          </Card>
        </Col>
      </Row>

      <Card className="shadow-sm border-0">
        <Card.Body>
          <div className="d-flex justify-content-between align-items-center mb-3">
            <h5>Detailed Recurring Expenses</h5>

          </div>
          <Table striped bordered hover responsive>
            <thead>
              <tr>
                <th>#</th>
                <th>Expense Item</th>
                <th>Category</th>
                <th>Amount (KES)</th>
                <th>Date Added</th>
                <th>Added By</th>
              </tr>
            </thead>
            <tbody>
              {fullExpenses.map((exp, index) => (
                <tr key={index}>
                  <td>{index + 1}</td>
                  <td>{exp.item}</td>
                  <td>{exp.category}</td>
                  <td>{exp.amount.toLocaleString()}</td>
                  <td>{exp.date}</td>
                  <td>{exp.by}</td>
                </tr>
              ))}
            </tbody>
          </Table>
        </Card.Body>
      </Card>
    </div>
  );
}

export default MonthlyTargetsComp;